var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"options-bar",on:{"click":function($event){_vm.$parent.optionsExpanded = false}}},[_c('nav-button',{attrs:{"title":"Settings","link":"/settings"}}),_c('nav-button',{attrs:{"title":"View Bucket","global-event":"toggleBucket"}}),_c('nav-button',{attrs:{"title":"Logout","link":"/logout","accent":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }